'use es6';

import $ from 'jquery';
const isSaveShortcut = event => {
  const sPressed = event.keyCode === 83;
  const ctrlPressed = event.ctrlKey; // for checking non-OSX
  const altPressed = event.altKey; // for checking ctrl+alt together
  const cmdPressed = event.metaKey; // cmd on OSX, Win key on Windows
  return sPressed && (cmdPressed || ctrlPressed && !altPressed);
};
const handleKeydownEvent = (event, callback) => {
  if (!isSaveShortcut(event)) {
    return;
  }
  event.preventDefault();
  event.stopPropagation();
  if (callback) {
    callback();
  }
};
export const createSaveRequestListener = callback => {
  $(window).on('keydown', event => handleKeydownEvent(event, callback));
};
export const cleanSaveRequestListener = () => {
  $(window).off('keydown', handleKeydownEvent);
};